import { useQuery } from "@tanstack/react-query";
import adminApiClient, { SentToClockStats } from "../../api/admin";

export type SentToClockRange = { days: number } | { from: string; to: string };

export const useSentToClockStats = (range: SentToClockRange) => {
  return useQuery<SentToClockStats>({
    queryKey: ["sentToClockStats", range],
    queryFn: () => adminApiClient.getSentToClockStats(range),
    // The query scans a large table, so don't burn retries on a request that
    // cannot succeed: a 4xx means the range itself was rejected. Transient
    // failures still get the default retries.
    retry: (failureCount, error) => {
      const status = (error as { response?: { status?: number } })?.response
        ?.status;
      if (status && status >= 400 && status < 500) return false;
      return failureCount < 3;
    },
  });
};
